module.exports = __webpack_public_path__ + "static/media/stocks-13.583e0179.jpg";